module.exports = __webpack_public_path__ + "img/look11.3ba4cffa.png";